import { Component } from '@angular/core';
import { ConsentManagementFormComponent, SupplementHashAnchorsPipe } from "@spartacus/storefront";

@Component({
    selector: 'app-efa-consent-management-form',
    templateUrl: './efa-consent-management-form.component.html',
    imports: [SupplementHashAnchorsPipe]
})
export class EfaConsentManagementFormComponent extends ConsentManagementFormComponent {

}
